import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/report-leave-initial-balances', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = attributes => {
  return httpClient
    .post('/api/report-leave-initial-balances/export', attributes, { responseType: 'arraybuffer' })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const leaveType = (options = {}) => {
  return httpClient
    .get('/api/report-leave-initial-balances/leave-types', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, exportExcel, leaveType }
